<section class="relative flex items-center gap-3">
    <article class="rounded w-full h-10">
      <app-input-search [placeholder]="placeholder" [searchValue]="searchValue" [width]="'full'" (submitEventEmitter)="search($event)"></app-input-search>
    </article>
    @if (searching) {
      <img [src]="images.loading" alt="" aria-hidden="true" class="h-10 w-10" />
    }
    <button
      #filterToggle
      class="search-bar-button inline-flex shrink-0 items-center gap-2 rounded px-2 py-2 font-bold text-gray-800 focus-visible:outline-2 focus-visible:outline-primary-purple"
      [class.opened]="filterOpened() || filtersApplied() > 0"
      [class.filtersApplied]="filtersApplied() > 0"
      [attr.aria-expanded]="filterOpened()"
      aria-controls="services-filter-panel"
      [attr.aria-label]="filterButtonLabel()"
      (click)="toggleFilter()"
    >
      <img [src]="images.filter" alt="" aria-hidden="true" class="h-6 w-6" [class.filter-primary-purple-light]="filterOpened()" />
      @if (filtersApplied() > 0) {
        <span class="text-[14px] font-bold text-primary-purple-light" aria-hidden="true">({{ filtersApplied() }})</span>
      }
    </button>
    <article
      id="services-filter-panel"
      class="absolute left-0 top-full z-40 mt-3 w-max max-w-[90vw]"
      [class.hidden]="!filterOpened()"
      (keydown.escape)="closeFilter()"
    >
      <app-filter-panel
        [fields]="filterFields"
        [filterType]="filterTypes.SERVICES"
        [selection]="filterSelection()"
        (filter)="onFilter($event)"
        (closeFilter)="filterOpened.set(false)"
      />
    </article>
  </section>
